// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/VectorStroke.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MovementModal_overlay__yRVcx {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.MovementModal_modal__LtELo {
  background: #fff;
  border-radius: 12px;
  width: 500px;
  max-width: 90%;
  padding: 24px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.MovementModal_header__BACy8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.MovementModal_title__jxav1 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
}

.MovementModal_closeButton__Tekf6 {
  background: none;
  border: none;
  font-size: 30px;
  cursor: pointer;
}

.MovementModal_content__SqpFO {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  margin: 32px 0;
}

.MovementModal_column__XZbia {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1;
  background: rgba(249, 249, 249, 1);
  padding: 12px;
}

.MovementModal_radioLabel__oGIC6 {
  display: flex;
  align-items: center; /* выравнивание кружка и текста по центру */
  gap: 8px; /* расстояние между кружком и текстом */
  margin-bottom: 6px;
  font-size: 14px;
  cursor: pointer;
}

.MovementModal_radioLabel__oGIC6 input[type="radio"] {
  appearance: none;   /* убираем стандартный кружок */
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 16px;
  height: 16px;
  border: 2px solid #2e7d32;
  border-radius: 50%;
  display: grid;
  place-content: center;
  cursor: pointer;
}

.MovementModal_radioLabel__oGIC6 input[type="radio"]::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  transform: scale(0);
  transition: 0.2s ease-in-out;
  background-color: #2e7d32;
}

.MovementModal_radioLabel__oGIC6 input[type="radio"]:checked::before {
  transform: scale(1);
}


.MovementModal_arrow__1Yctb {
  width: 15px;
  height: 16.13px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  margin: 0 19.24px;
}

.MovementModal_textarea__3Sb5N {
  width: 100%;
  height: 80px;
  resize: none;
  margin-bottom: 32px;
  border: 1px solid rgba(203, 213, 225, 1);
  border-radius: 6px;
  padding: 16px 12px;
  font-size: 14px;
  text-align: left;
}

.MovementModal_footer__FO4r3 {
  display: flex;
  justify-content: space-between;
}

.MovementModal_cancel__zy6jz {
  background: none;
  border: 1px solid rgba(115, 115, 115, 1);
  color: rgba(115, 115, 115, 1);
  padding: 10.5px 24px;
  border-radius: 4px;
  cursor: pointer;
}

.MovementModal_submit__8AWs2 {
  background: rgba(29, 135, 82, 1);
  color: white;
  border: none;
  padding: 10.5px 24px;
  border-radius: 4px;
  cursor: pointer;
}

.MovementModal_titleHeading__Ldr\\+Z {
    font-weight: 700;
    font-size: 18px;
}

.MovementModal_scrollable__SWmso {
  max-height: 200px; /* можно подправить по дизайну */
  overflow-y: auto;
  padding-right: 6px;
}

/* Красивый скролл */
.MovementModal_scrollable__SWmso::-webkit-scrollbar {
  width: 6px;
}

.MovementModal_scrollable__SWmso::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.MovementModal_scrollable__SWmso::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.MovementModal_truncate__-FUMg {
  display: inline-block;
  max-width: 130px; /* задай ширину, которая тебе подходит */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

`, "",{"version":3,"sources":["webpack://./src/styles/MovementModal.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,2CAA2C;EAChE,QAAQ,EAAE,uCAAuC;EACjD,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB,IAAI,+BAA+B;EACnD,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,yDAA+C;EAC/C,wBAAwB;EACxB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;EACE,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB,EAAE,wCAAwC;EAC1D,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n}\n\n.modal {\n  background: #fff;\n  border-radius: 12px;\n  width: 500px;\n  max-width: 90%;\n  padding: 24px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  font-size: 30px;\n  cursor: pointer;\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n  margin: 32px 0;\n}\n\n.column {\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n  background: rgba(249, 249, 249, 1);\n  padding: 12px;\n}\n\n.radioLabel {\n  display: flex;\n  align-items: center; /* выравнивание кружка и текста по центру */\n  gap: 8px; /* расстояние между кружком и текстом */\n  margin-bottom: 6px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.radioLabel input[type=\"radio\"] {\n  appearance: none;   /* убираем стандартный кружок */\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 16px;\n  height: 16px;\n  border: 2px solid #2e7d32;\n  border-radius: 50%;\n  display: grid;\n  place-content: center;\n  cursor: pointer;\n}\n\n.radioLabel input[type=\"radio\"]::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  transform: scale(0);\n  transition: 0.2s ease-in-out;\n  background-color: #2e7d32;\n}\n\n.radioLabel input[type=\"radio\"]:checked::before {\n  transform: scale(1);\n}\n\n\n.arrow {\n  width: 15px;\n  height: 16.13px;\n  background-image: url(/public/VectorStroke.png);\n  background-size: contain;\n  background-repeat: no-repeat;\n  margin: 0 19.24px;\n}\n\n.textarea {\n  width: 100%;\n  height: 80px;\n  resize: none;\n  margin-bottom: 32px;\n  border: 1px solid rgba(203, 213, 225, 1);\n  border-radius: 6px;\n  padding: 16px 12px;\n  font-size: 14px;\n  text-align: left;\n}\n\n.footer {\n  display: flex;\n  justify-content: space-between;\n}\n\n.cancel {\n  background: none;\n  border: 1px solid rgba(115, 115, 115, 1);\n  color: rgba(115, 115, 115, 1);\n  padding: 10.5px 24px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit {\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  border: none;\n  padding: 10.5px 24px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.titleHeading {\n    font-weight: 700;\n    font-size: 18px;\n}\n\n.scrollable {\n  max-height: 200px; /* можно подправить по дизайну */\n  overflow-y: auto;\n  padding-right: 6px;\n}\n\n/* Красивый скролл */\n.scrollable::-webkit-scrollbar {\n  width: 6px;\n}\n\n.scrollable::-webkit-scrollbar-thumb {\n  background-color: #888;\n  border-radius: 4px;\n}\n\n.scrollable::-webkit-scrollbar-thumb:hover {\n  background-color: #555;\n}\n\n.truncate {\n  display: inline-block;\n  max-width: 130px; /* задай ширину, которая тебе подходит */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `MovementModal_overlay__yRVcx`,
	"modal": `MovementModal_modal__LtELo`,
	"header": `MovementModal_header__BACy8`,
	"title": `MovementModal_title__jxav1`,
	"closeButton": `MovementModal_closeButton__Tekf6`,
	"content": `MovementModal_content__SqpFO`,
	"column": `MovementModal_column__XZbia`,
	"radioLabel": `MovementModal_radioLabel__oGIC6`,
	"arrow": `MovementModal_arrow__1Yctb`,
	"textarea": `MovementModal_textarea__3Sb5N`,
	"footer": `MovementModal_footer__FO4r3`,
	"cancel": `MovementModal_cancel__zy6jz`,
	"submit": `MovementModal_submit__8AWs2`,
	"titleHeading": `MovementModal_titleHeading__Ldr+Z`,
	"scrollable": `MovementModal_scrollable__SWmso`,
	"truncate": `MovementModal_truncate__-FUMg`
};
export default ___CSS_LOADER_EXPORT___;
